// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jl-2";
export var container = "_jl-4";
export var dismissButton = "_jl-3";
export var hasPaddingBottom = "_jl-6";
export var last = "_jl-e";
export var scrollbarThumb = "_jl-c";
export var scrollbarTrack = "_jl-b";
export var selected = "_jl-9";
export var spin = "_jl-1";
export var spinning = "_jl-0";
export var suggestionItem = "_jl-d";
export var suggestionsPanel = "_jl-5";
export var tonePill = "_jl-8";
export var tonesContainer = "_jl-7";
export var unselected = "_jl-a";